<template>
  <section class="story01">
    <div class="story01--con">
      <div class="story01--subtit">
        <div class="subtit-bold">Brand</div><div class="subtit-light">Story</div>
      </div>
      <div class="story01--visual">
        <div class="story01--txt">
          <p class="mb-2">
          보타랩은<span class="brs"></span> 보태니컬 래버러토리(Botanical Laboratory), <br><span class="brs"></span>
          즉 "식물연구소"라는 뜻으로 자연과 과학의 만남을 의미합니다.
          </p>
          자연 유래 성분 중심으로 수년간의 실험과 연구를 바탕으로 건강하고 아름다운 삶에 대한 순수하고 강렬한 에너지를 선사합니다.
        </div>
      </div>  
    </div>
  </section>
</template>

<script>
export default {
  name: 'Section1',
}
</script>